var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ais-toggle-refinement", {
    attrs: { attribute: _vm.attribute, label: _vm.label },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function ({ value, refine }) {
            return [
              _c(
                "ci-checkbox",
                {
                  attrs: {
                    label: _vm.label,
                    value: value.isRefined,
                    vCenter: true,
                    name: _vm.attribute,
                  },
                  on: {
                    change: function ($event) {
                      return refine(value)
                    },
                  },
                },
                [_vm._t("default")],
                2
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }